import React from 'react';
import { Watermark } from '../slide/Watermark';
import { SlideView } from './SlideView';
export const ProjectPageContent = (props) => {
    const { pageId, viewBox, hideWatermark = false } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(SlideView, { id: pageId, viewBox: viewBox }),
        !hideWatermark && React.createElement(Watermark, null)));
};
